<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-12">
        <h2>Personal
        <configTools 
          [rowsExport]="rowsExport"
          [Title]="tituloTabla"
          [Permiso]=false
          ></configTools>
        </h2>
    </div>
</div>

<div class="ibox">
  <div class="ibox-content">
    <div class="row">
      <div class="col-lg">
        <form (ngSubmit)="onSubmit()" [formGroup]="registerForm">
            <div>
                <label class="col-form-label font-bold">Grupo Liquidación</label>
                <comboTools
                    [list]=gruposLiquidacionList
                    selected='grupoLiq'
                    [formParent]="registerForm"
                    filter="descripcion"
                    ph='Grupo Liquidación'
                ></comboTools>
            </div>
        </form>
      </div>
      <div class="col-lg">
          <form (ngSubmit)="onSubmit()" [formGroup]="registerForm">
          <div>
              <label class="col-form-label font-bold">Sociedad</label>
              <comboTools
                  [list]=sociedadesList
                  selected='sociedad'
                  [formParent]="registerForm"
                  filter="descripcion"
                  ph='Sociedad'
              ></comboTools>
          </div>
          </form>
      </div>
    </div>
    <div class="row">
      <div class="col-lg">
          <form (ngSubmit)="onSubmit()" [formGroup]="registerForm">
          <div>
              <label class="col-form-label font-bold">Sede</label>
              <comboTools
                  [list]=sedesList
                  selected='sede'
                  [formParent]="registerForm"
                  filter="descripcion"
                  (SelectedChange)="onChangeSede($event)"
                  ph='Sede'
              ></comboTools>
          </div>
          </form>
      </div>
      <div class="col-lg">
          <form (ngSubmit)="onSubmit()" [formGroup]="registerForm">
          <div>
              <label class="col-form-label font-bold">Subsede</label>
              <comboTools
                  [list]=subsedesList
                  selected='subSede'
                  [formParent]="registerForm"
                  filter="descripcion"
                  ph='Subsede'
              ></comboTools>
          </div>
          </form>
      </div>
    </div>
    <div class="row">
      <div class="col-lg">
          <form (ngSubmit)="onSubmit()" [formGroup]="registerForm">
          <div>
              <label class=" col-form-label font-bold">Legajo</label>
              <input formControlName="legajo" name ="selectedLegajo" type="number" class="form-control" [ngClass]="{ 'is-invalid': registerFormControl.legajo.errors }"/>
          </div>
          </form>
      </div>
      <div class="col-lg">
        <br>
        <div class="buttons">
          <button class="btn btn-secondary" type="submit" (click)="verResultados()">Ver</button>
        </div>
        
      </div>
    </div>  

    <div *ngIf="showDetails">
      <div class="table table-striped">
        <p-table #dt [value]="empleados" [rows]="10" [paginator]="true" [globalFilterFields]="['nombre', 'apellido', 'segundoApellido', 'legajo']"
                  [rowHover]="true" dataKey="id"
                  currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} empleados" [showCurrentPageReport]="true">
          <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-center p-jc-between">
              <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text" class="p-inputtext p-component" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Buscar..." />
              </span>
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 5rem" pSortableColumn="legajo">Legajo <p-sortIcon field="legajo"></p-sortIcon></th>
              <th pSortableColumn="nombre">Nombre <p-sortIcon field="nombre"></p-sortIcon></th>
              <th pSortableColumn="grupoLiq">Grupo Liquidación <p-sortIcon field="grupoLiq"></p-sortIcon></th>
              <th pSortableColumn="sociedad">Sociedad <p-sortIcon field="sociedad"></p-sortIcon></th>
              <th pSortableColumn="sede">Sede <p-sortIcon field="sede"></p-sortIcon></th>
              <th pSortableColumn="subSede">Subsede <p-sortIcon field="subSede"></p-sortIcon></th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-empleado let-rowIndex="rowIndex">
            <tr>
              <td style='text-align:right'>{{empleado.legajo}}</td>
              <td>{{empleado.apellido}}, {{empleado.nombre}}</td>
              <td>{{empleado.datosOrganizativos[0].grupoLiquidacionNavigation.codigo}}</td>
              <td>{{empleado.datosOrganizativos[0].sociedadNavigation.descripcion}}</td>
              <td>{{empleado.datosOrganizativos[0].sedeNavigation.descripcion}}</td>
              <td>{{empleado.datosOrganizativos[0].subSedeNavigation.descripcion}}</td>
              <td>
                <button *ngIf="permisoEdicion" pButton pRipple pTooltip="Ver Detalle" tooltipPosition="bottom" icon="pi pi-eye" class="btn btn-xs btn-info" (click)="abrirDetalle(empleado, rowIndex)"></button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
